(() => {
  if (window.AdoredNavigation) return;
  window.AdoredNavigation = true;
  const closeMenus = except => {
    document.querySelectorAll('[data-ak-top-menu][open]').forEach(menu => {
      if (menu !== except) menu.open = false;
    });
  };
  document.addEventListener('toggle', event => {
    if (event.target.matches('[data-ak-top-menu]') && event.target.open) closeMenus(event.target);
  }, true);
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-ak-header-menu]')) closeMenus();
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const menu = event.target.closest('[data-ak-top-menu][open]');
    if (!menu) return;
    event.preventDefault();
    event.stopPropagation();
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest('[data-ak-header-menu]')) closeMenus();
  });
  matchMedia('(min-width: 1024px)').addEventListener('change', () => closeMenus());
})();
